import { ContextualMenuItem, IContextualMenuItemProps } from '@fluentui/react/lib/ContextualMenu';
import * as React from 'react';


const CustomCommandBarMenuItem: React.FunctionComponent<IContextualMenuItemProps> = props => {
    return <ContextualMenuItem {...props} hasIcons={false}  />;
};
export default CustomCommandBarMenuItem;
